<template>
  <div class="view" :class="{full: $route.query.hide=='true'}">
    <Error v-if="error" :error="error"/>
    <Loading v-if="loading"/>
    <template v-if="!loading&&$route.params.folder">
      <div class="info">
        {{$t('db.filename')}}: {{current().name}}<br>
        <a target="_blank" v-if="filepath()" :href="filepath()">{{$t('db.download')}}</a>
      </div>
      <div class="content">
        <div class="video" v-if="current().type==1||current().type==5">
          <NativeVideo :url="filepath()"
            :subtitle="current().type==1?`./data/subtitles/${$route.params.id.toLowerCase()}_${$i18n.locale}.vtt`:null"/>
        </div>
        <div class="video" v-if="current().type==4&&current().video">
          <NativeVideo :url="`./videos/${current().video}.mp4`"
            :subtitle="`./data/subtitles/${current().video}_${$i18n.locale}.vtt`"/>
        </div>
        <div class="ingame" v-if="current().type==4&&!current().video">{{$t('db.ingame')}}</div>
        <div class="audio" v-if="current().type==2||current().type==6">
          <AudioPlayer theme="#2d303a" :music="{
            pic: './empty.png',
            src: filepath(),
            title: current().name,
            artist: $route.params.id,
          }" preload/>
        </div>
        <div class="image" v-if="current().type==3">
          <img :alt="$route.params.id" :src="imagePath()" @click="viewImage(imagePath())">
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import lightbox from '@/lightbox';
import Error from '../Error';
import Loading from '../Loading';

import NativeVideo from '../NativeVideo';
import AudioPlayer from 'vue-aplayer';

export default {
  name: 'QueryDB',
  data() {
    return {
      error: null,
      loading: null,
      dblist: null,
    };
  },
  components: {
    Error,
    Loading,
    NativeVideo,
    AudioPlayer,
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    viewImage(url) {
      lightbox.show(url);
    },
    current() {
      if (!this.dblist) return {};
      return this.dblist[this.$route.params.folder].files[this.$route.params.id];
    },
    // pictures with transparency are png (flagged "ext" by the converter), the others jpg
    imagePath() {
      return `./images/gallery/${this.$route.params.id}.${this.current().ext || 'jpg'}`;
    },
    filepath() {
      switch (this.current().type) {
        case 1:
          return `./videos/${this.$route.params.id}.mp4`;
        case 2:
          return `./audios/story/${this.$route.params.id}.mp3`;
        case 3:
          return false;
        case 4:
          return false;
        case 5:
          return `${this.current().location}/${this.$route.params.id}.mp4`;
        case 6:
          return `${this.current().location}/${this.$route.params.id}.mp3`;
        default:
          return false;
      }
    },
    fetchData() {
      if (!this.$route.params.folder) return;
      this.error = this.dblist = null;
      this.loading = true;
      fetch("./data/dblist.json").then(res => {
        this.loading = false;
        if (res.ok) res.json().then(data=>{
          this.dblist = data;
        }); else {
          this.error = res.status+' '+res.statusText;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  flex: 1 1 0;
  min-width: 0;
  @media screen and (max-width: 767px) {
    flex-basis: 100%;
  }
  height: 100%;
  padding: 16px;
  overflow-x: hidden;
  overflow-y: scroll;
  display: inline-block;
  box-sizing: border-box;
  .info {
    margin-bottom: 16px;
  }
  .loading {
    width: calc(80vw - 332px);
    @media screen and (max-width: 767px) {
      width: calc(100vw);
    }
  }
  .aplayer {
    color: #fff;
    background: var(--panel);
    aplyer-icon:hover {
      opacity: .2;
    }
  }
  .ingame {
    color: var(--dim);
  }
  .image img {
    max-width: 100%;
    background: rgba(160, 160, 160, .18);   /* translucent grey plate, like in the game */
  }
}
</style>
